import React from "react";
import CompanyInfo from "./components/CompanyInfo";
import ContactInfo from "./components/ContactInfo";
import SocialMedia from "./components/SocialMedia";
import AppDownloads from "./components/AppDownloads";
import ReportChannel from "./components/ReportChannel";
import SponsorLogos from "./components/SponsorLogos";
import { APP_VERSION } from "../../constants/app";
import "./Footer.css";

// Imports das imagens
import logoForluz from "../../assets/img/logo-forluz-laranja.svg";
import logoPrevic from "../../assets/img/logo_Previc.png";
import cemig from "../../assets/img/cemig.svg";
import cemigsaude from "../../assets/img/cemigSaude.svg";
import gasmig from "../../assets/img/gasmig.svg";
import taesa from "../../assets/img/taesa.svg";
import indi from "../../assets/img/investMinas.svg";
import efficientia from "../../assets/img/cemigSim.svg";

const Footer: React.FC = () => {
  const socialLinks = {
    instagram: "https://www.instagram.com/forluz_oficial/",
    facebook: "https://www.facebook.com/forluz.org/",
    youtube: "https://www.youtube.com/user/comunicacaoforluz",
    telegram: "https://t.me/+rVpfSec-JERhOTIx",
    soundcloud: "https://soundcloud.com/forluz",
    linkedin: "https://www.linkedin.com/company/forluz",
    spotify: "https://open.spotify.com/show/08QDGkndNKKGT8YYzgyC96?si=34gtn0GUTBuD19jSkTBrdA",
  };

  const sponsorLogos = {
    cemig,
    cemigsaude,
    gasmig,
    taesa,
    indi,
    efficientia,
  };

  return (
    <footer className="footer-container">
      <div className="footer-inner">
        {/* Coluna Esquerda - Informações da Empresa */}
        <div className="footer-left-column">
          <CompanyInfo logoForluz={logoForluz} />
          <ContactInfo />
          <SocialMedia socialLinks={socialLinks} />
          <AppDownloads
            appStoreUrl="https://apps.apple.com/br/app/forluz/id1195834897"
            playStoreUrl="https://play.google.com/store/apps/details?id=br.org.forluz.app&hl=pt_BR"
          />
          <ReportChannel
            href="../Governanca/canal-de-denuncia"
            text="Canal de denúncia"
          />
        </div>

        {/* Coluna Direita - Logos das Patrocinadoras */}

        <div className="footer-right-column">
          <div className="footer-previc-section">
            <a
              href="https://www.gov.br/previc/pt-br"
              target="_blank"
              rel="noreferrer"
              className="footer-previc-link"
            >
              <img
                src={logoPrevic}
                alt="PREVIC"
                className="footer-previc-logo"
              />
            </a>
          </div>

          <span className="footer-sponsors-label">Patrocinadoras</span>

          <SponsorLogos logos={sponsorLogos} />
        </div>
      </div>

      {/* Versão oculta */}
      <p className="footer-version">{APP_VERSION}</p>
    </footer>
  );
};

export default Footer;
